// extracted by mini-css-extract-plugin
module.exports = {"layout":"Compose_layout__SDlBd","back":"Compose_back__IhMnq"};